'use client';

import { If } from '@payments-checkout/shared/components';
import { useEffect, useState, type ReactNode } from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';
import { SummaryTrigger } from './summaryTrigger';

type SummaryDynamicViewProps = {
  content: ReactNode;
  formattedAmount: string;
  suppressOnMobile?: boolean;
  screen: string;
};

export function SummaryDynamicView({
  content,
  formattedAmount,
  suppressOnMobile = true,
  screen,
}: SummaryDynamicViewProps) {
  const { width } = useWindowSize();
  const [isContentVisible, setIsContentVisible] = useState(true);
  const isSmallView = width <= 500;

  useEffect(() => {
    if (isSmallView && suppressOnMobile) {
      setIsContentVisible(false);
    }
    if (!isSmallView) {
      setIsContentVisible(true);
    }
  }, [isSmallView, suppressOnMobile]);

  return (
    <>
      <If condition={isSmallView && suppressOnMobile}>
        <SummaryTrigger
          value={formattedAmount}
          trigger={() => setIsContentVisible((prev) => !prev)}
          isContentVisible={isContentVisible}
          screen={screen}
        />
      </If>
      <If condition={isContentVisible}>{content}</If>
    </>
  );
}
